import { Link } from "react-router-dom";
import type { Drama } from "@/types";

interface DramaCardProps {
  drama: Drama;
  showFavorite?: boolean;
  favorited?: boolean;
}

export default function DramaCard({ drama, showFavorite, favorited }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title}海报`}
          title={`${drama.title} - 仙剑奇侠传影视站`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent"></div>
        <span className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 rounded-full bg-black/55 text-accent-200 text-xs">
          <i className="ri-star-fill text-accent-300"></i>
          {drama.rating.toFixed(1)}
        </span>
        {showFavorite && favorited && (
          <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-accent-500 text-foreground-950 flex items-center justify-center text-sm">
            <i className="ri-bookmark-fill"></i>
          </span>
        )}
        <span className="absolute bottom-3 left-3 text-xs text-background-100/90">
          {drama.year} · {drama.category}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {drama.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
          {drama.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {drama.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}